module.exports = __webpack_public_path__ + "img/a_3.b38a1d3f.png";